module.exports = __webpack_public_path__ + "img/spiral-details12.599b6f12.png";